import DrawerHeader from '../containers/Drawer/DrawerHeader'
import Loadable from 'react-loadable'
import LoadingComponent from 'rmw-shell/lib/components/LoadingComponent'
import React from 'react'
import getMenuItems from './menuItems'
import grants from './grants'
import locales from './locales'
import routes from './routes'
import themes from './themes'

const Loading = () => <LoadingComponent />

const LPAsync = Loadable({
  loader: () => import('../../src/pages/LandingPage'),
  loading: Loading,
})

const config = {
  firebase_config: {
    apiKey: 'AIzaSyBtukIk-RQ5yaZLxEeTZxi6B6DDbae6skc',
    authDomain: 'smart-scan-2f962.firebaseapp.com',
    databaseURL: 'https://smart-scan-2f962.firebaseio.com',
    projectId: 'smart-scan-2f962',
    storageBucket: 'smart-scan-2f962.appspot.com',
    messagingSenderId: '663732840026',
    appId: '1:663732840026:web:0ec2160e9bd08835',
  },
  firebase_config_dev: {
    apiKey: 'AIzaSyBtukIk-RQ5yaZLxEeTZxi6B6DDbae6skc',
    authDomain: 'smart-scan-2f962.firebaseapp.com',
    databaseURL: 'https://smart-scan-2f962.firebaseio.com',
    projectId: 'smart-scan-2f962',
    storageBucket: 'smart-scan-2f962.appspot.com',
    messagingSenderId: '663732840026',
    appId: '1:663732840026:web:0ec2160e9bd08835',
  },
  firebase_config_devd: {
    apiKey: 'AIzaSyCBeMFW1YML6bMa5e9iJDYT-MWksAFe6eE',
    authDomain: 'smart-scan-dev.firebaseapp.com',
    databaseURL: 'https://smart-scan-dev.firebaseio.com',
    projectId: 'smart-scan-dev',
    storageBucket: 'smart-scan-dev.appspot.com',
    messagingSenderId: '475669054843',
    appId: '1:475669054843:web:c95edc278b2b75aa',
  },
  firebase_providers: ['password'],
  initial_state: {
    themeSource: {
      isNightModeOn: true,
      source: 'light',
    },
    locale: 'de',
  },
  algolia: {
    appID: process.env.NODE_ENV !== 'production' ? 'ZIX19ET5N8' : 'ZIX19ET5N8',
    apiKey:
      process.env.NODE_ENV !== 'production'
        ? '397e42d04674c4ecfd1efe53ed991275'
        : '397e42d04674c4ecfd1efe53ed991275',
  },
  drawer_width: 256,
  locales,
  themes,
  grants,
  routes,
  getMenuItems,
  firebaseLoad: () => import('./firebase'),
  drawerHeader: DrawerHeader,
  onAuthStateChanged: (user, props, firebaseApp) => {
    const { watchList } = props

    watchList(firebaseApp, `client_user_grants/${user.uid}`)
    watchList(firebaseApp, 'clients')
  },
  landingPage: LPAsync,
}

export default config
